/* DPI Checker · interfaz (DTF Transfers Now)
 *
 * El análisis lo hace dpi-checker-engine.js en un Web Worker, en el navegador
 * del cliente: el archivo no se sube a ningún sitio. Aquí está la pantalla:
 * subir, progreso, resultado y «no se puede revisar».
 *
 * Reglas de la casa que respeta: solo se detecta y se explica (nada de
 * arreglos automáticos), nunca se bloquea la compra, y los textos siguen la
 * guía de marca (Title Case en titulares, números menores de 10 en letra,
 * Same-Day siempre con su corte).
 */
(function () {
  'use strict';

  var root = document.getElementById('dpic');
  if (!root) return;
  var cfg = {};
  try { cfg = JSON.parse(root.getAttribute('data-config') || '{}'); } catch (e) { cfg = {}; }
  // el worker nace de un blob: las rutas de los assets tienen que ser absolutas
  ['engine', 'pdf', 'pdfWorker'].forEach(function (k) { if (cfg[k]) { try { cfg[k] = new URL(cfg[k], location.href).href; } catch (e) { /* se queda como está */ } } });
  var URLS = cfg.urls || {};
  var SHEETS = cfg.sheets || {
    '22': { name: 'Custom Gang Sheets', lengths: [6, 12, 24, 36, 48, 60, 72, 84, 96, 108, 120, 132, 144, 156, 168, 180, 192, 204, 216, 228, 240, 300] },
    '24': { name: 'Heat Transfer Max', lengths: [24, 36, 48, 60, 72, 84, 96, 108, 120, 240, 300] },
    '30': { name: 'Wide Format', lengths: [36, 48, 60, 72, 84, 96, 108, 120, 240, 300] }
  };
  var MAX_MB = cfg.maxMb || 250, MAX_MP = 850, MAX_SPOTS = 24;

  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var state = {
    mode: 'single', printW: null, sheetW: 22, sheetL: 120,
    files: [], active: 0, spot: -1, zoom: false, busy: false, token: 0
  };

  // ============================== ICONOS ==============================
  function svg(paths, size, sw) {
    return '<svg width="' + (size || 20) + '" height="' + (size || 20) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (sw || 2) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + paths + '</svg>';
  }
  var IC = {
    alert: '<circle cx="12" cy="12" r="9"></circle><path d="M12 7v6"></path><path d="M12 16.5h.01"></path>',
    check: '<path d="M5 12l5 5 9-10"></path>',
    okc: '<circle cx="12" cy="12" r="9"></circle><path d="M8 12l3 3 5-6"></path>',
    back: '<path d="M19 12H5"></path><path d="M11 6l-6 6 6 6"></path>',
    next: '<path d="M5 12h14"></path><path d="M13 6l6 6-6 6"></path>',
    file: '<path d="M14 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7l-4-4z"></path><path d="M14 3v4h4"></path>',
    up: '<path d="M12 16V4"></path><path d="M7 9l5-5 5 5"></path><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"></path>',
    tip: '<path d="M9 18h6"></path><path d="M10 21h4"></path><path d="M12 3a6 6 0 0 0-4 10.5c.8.8 1 1.5 1 2.5h6c0-1 .2-1.7 1-2.5A6 6 0 0 0 12 3z"></path>'
  };

  // ============================== TEXTO ==============================
  var NUM = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  function num(n) { return n < 10 ? NUM[n] : String(n); }
  function things(n) { return num(n) + (n === 1 ? ' Thing' : ' Things'); }
  function fin(x) { var r = Math.round(x * 10) / 10; return (Math.abs(r - Math.round(r)) < 0.05) ? String(Math.round(r)) : r.toFixed(1); }
  function fmb(bytes) { return bytes >= 1e9 ? (bytes / 1e9).toFixed(1) + ' GB' : bytes >= 1e6 ? Math.round(bytes / 1e6) + ' MB' : Math.max(1, Math.round(bytes / 1e3)) + ' KB'; }
  function ft(inches) { return inches % 12 === 0 && inches >= 12 ? (inches / 12) + ' ft · ' + inches + ' in' : inches + ' in'; }
  function link(href, text) { return '<a href="' + esc(href || '#') + '">' + text + '</a>'; }

  function track(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var ev = { event: name };
      for (var k in params) ev[k] = params[k];
      window.dataLayer.push(ev);
    } catch (e) { /* sin medición */ }
  }

  // ============================== MOTOR (worker, o el hilo principal de reserva) ==============================
  var worker = null, jobs = {}, nextId = 1, mainEngine = null, sinWorker = false;

  function onEngineMessage(m) {
    var j = jobs[m.id];
    if (!j) return;
    if (m.type === 'progress') { if (j.progress) j.progress(m.stage, m.frac); }
    else if (m.type === 'result') { delete jobs[m.id]; j.resolve(m.result); }
    else if (m.type === 'crops') { delete jobs[m.id]; j.resolve(m.crops); }
    else if (m.type === 'error') { delete jobs[m.id]; j.reject(new Error(m.code)); }
  }

  function loadScript(src) {
    return new Promise(function (ok, ko) {
      var s = document.createElement('script');
      s.src = src; s.onload = ok; s.onerror = function () { ko(new Error('load')); };
      document.head.appendChild(s);
    });
  }

  function startWorker() {
    if (worker || mainEngine || sinWorker || !cfg.engine || /^file:/.test(location.protocol)) return;
    try {
      var blob = new Blob(['importScripts(' + JSON.stringify(cfg.engine) + ');'], { type: 'text/javascript' });
      worker = new Worker(URL.createObjectURL(blob));
      worker.onmessage = function (ev) { onEngineMessage(ev.data); };
      worker.onerror = function () { worker = null; sinWorker = true; reintentar(); };
    } catch (e) { worker = null; }
  }

  // Si el worker no arranca (un bloqueador, una política del navegador), lo que
  // estaba pedido se repite en el hilo principal: más lento, pero funciona.
  function reintentar() {
    var all = jobs; jobs = {};
    ensureEngine().then(function () {
      for (var id in all) {
        if (all[id].msg) { jobs[id] = all[id]; send(all[id].msg); }
        else all[id].reject(new Error('engine'));
      }
    }, function () { for (var id in all) all[id].reject(new Error('engine')); });
  }

  function failAll(code) {
    var all = jobs; jobs = {};
    for (var id in all) all[id].reject(new Error(code));
  }

  async function ensureEngine() {
    startWorker();
    if (worker) return;
    if (!mainEngine) {
      if (!window.DPICEngine) await loadScript(cfg.engine);
      mainEngine = window.DPICEngine;
    }
  }

  function send(msg, transfer) {
    if (worker) worker.postMessage(msg, transfer || []);
    else setTimeout(function () { mainEngine.atender(msg, onEngineMessage); }, 0);
  }

  function call(msg, progress, transfer) {
    return new Promise(function (resolve, reject) {
      msg.id = nextId++;
      jobs[msg.id] = { resolve: resolve, reject: reject, progress: progress, msg: msg };
      send(msg, transfer);
    });
  }

  function cancelAll() {
    state.token++;
    if (worker) { worker.terminate(); worker = null; }
    failAll('cancelled');
  }

  // ============================== PDF · AI · SVG: se dibujan aquí y se mandan por filas ==============================
  async function pdfLib() {
    if (!window.pdfjsLib) await loadScript(cfg.pdf);
    window.pdfjsLib.GlobalWorkerOptions.workerSrc = cfg.pdfWorker;
    return window.pdfjsLib;
  }

  function mul(m1, m2) {
    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3],
      m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
  }

  // cada imagen incrustada con el tamaño al que está colocada: de ahí sale su resolución real
  async function pdfRasters(lib, page) {
    var out = [];
    try {
      var ops = await page.getOperatorList(), OPS = lib.OPS, ctm = [1, 0, 0, 1, 0, 0], stack = [];
      for (var i = 0; i < ops.fnArray.length; i++) {
        var fn = ops.fnArray[i], a = ops.argsArray[i];
        if (fn === OPS.save) stack.push(ctm);
        else if (fn === OPS.restore) ctm = stack.pop() || ctm;
        else if (fn === OPS.transform) ctm = mul(ctm, a);
        else if (fn === OPS.paintFormXObjectBegin) { stack.push(ctm); if (a && a[0]) ctm = mul(ctm, a[0]); }
        else if (fn === OPS.paintFormXObjectEnd) ctm = stack.pop() || ctm;
        else if (fn === OPS.paintImageXObject || fn === OPS.paintInlineImageXObject) {
          var wpx = 0, hpx = 0;
          if (fn === OPS.paintInlineImageXObject && a[0]) { wpx = a[0].width; hpx = a[0].height; }
          else { wpx = a[1]; hpx = a[2]; }
          var win = Math.hypot(ctm[0], ctm[1]) / 72, hin = Math.hypot(ctm[2], ctm[3]) / 72;
          if (wpx > 0 && hpx > 0 && win > 0.05 && hin > 0.05) {
            out.push({ anchoPx: wpx, altoPx: hpx, anchoIn: win, altoIn: hin, dpi: Math.min(wpx / win, hpx / hin) });
          }
        }
      }
    } catch (e) { /* sin lista de imágenes: se revisa igual lo demás */ }
    return out;
  }

  async function openPdf(f) {
    var lib = await pdfLib();
    var doc = await lib.getDocument({ data: new Uint8Array(await f.file.arrayBuffer()) }).promise;
    var page = await doc.getPage(1), vp = page.getViewport({ scale: 1 });
    f.pdf = { lib: lib, doc: doc, page: page };
    return { anchoIn: vp.width / 72, altoIn: vp.height / 72 };
  }

  function tileCanvas(w, h) {
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    return c;
  }

  async function checkVector(f, progress, token) {
    var dims, img = null, url = null, rasters = [];
    if (f.tipo === 'svg') {
      url = URL.createObjectURL(f.file);
      img = new Image();
      await new Promise(function (ok, ko) { img.onload = ok; img.onerror = function () { ko(new Error('bad-file')); }; img.src = url; });
      if (!img.naturalWidth || !img.naturalHeight) throw new Error('bad-file');
      dims = { anchoIn: img.naturalWidth / 96, altoIn: img.naturalHeight / 96 };
      f.svg = { img: img, url: url };
    } else {
      try { dims = await openPdf(f); } catch (e) { throw new Error(f.tipo === 'ai' ? 'ai-no-pdf' : 'bad-file'); }
      rasters = await pdfRasters(f.pdf.lib, f.pdf.page);
    }
    var W = Math.round(dims.anchoIn * 300), H = Math.round(dims.altoIn * 300);
    if (W < 1 || H < 1) throw new Error('bad-file');
    if (W * H / 1e6 > MAX_MP) throw new Error('too-large');
    var factor = (W * H / 1e6 > 150) ? 2 : 1, rw = Math.floor(W / factor), rh = Math.floor(H / factor);
    var th = Math.max(64, Math.min(2048, Math.floor(16e6 / rw))), cv = tileCanvas(rw, th), ctx = cv.getContext('2d', { willReadFrequently: true });
    var meta = { formato: f.tipo.toUpperCase(), vectorial: true, anchoIn: dims.anchoIn, altoIn: dims.altoIn, rasters: rasters };
    var id = nextId++;
    var done = new Promise(function (resolve, reject) { jobs[id] = { resolve: resolve, reject: reject, progress: progress }; });
    send({ cmd: 'begin', id: id, w: W, h: H, conAlfa: true, prescaled: factor === 2, meta: meta });
    var sc = 300 / 72 / factor;
    for (var y0 = 0; y0 < rh; y0 += th) {
      if (token !== state.token) { send({ cmd: 'drop', id: id }); throw new Error('cancelled'); }
      var n = Math.min(th, rh - y0);
      ctx.clearRect(0, 0, rw, th);
      if (img) {
        var k = img.naturalWidth / rw;
        ctx.drawImage(img, 0, y0 * k, img.naturalWidth, n * k, 0, 0, rw, n);
      } else {
        await f.pdf.page.render({ canvasContext: ctx, viewport: f.pdf.page.getViewport({ scale: sc, offsetX: 0, offsetY: -y0 }), background: 'rgba(0,0,0,0)' }).promise;
      }
      var d = ctx.getImageData(0, 0, rw, n).data;
      send({ cmd: 'rows', id: id, y: y0, n: n, buf: d.buffer }, [d.buffer]);
      progress('leer', Math.min(1, (y0 + n) / rh));
    }
    send({ cmd: 'end', id: id });
    return done;
  }

  // recorte de una zona (en pulgadas) para el zoom, de lo que se dibuja aquí
  async function cropVector(f, r, outPx) {
    var sc = outPx / r.w, cw = Math.max(1, Math.round(r.w * sc)), chh = Math.max(1, Math.round(r.h * sc));
    var cv = tileCanvas(cw, chh), ctx = cv.getContext('2d');
    if (f.svg) {
      var k = f.svg.img.naturalWidth / f.res.imgW;
      ctx.drawImage(f.svg.img, r.x * k, r.y * k, r.w * k, r.h * k, 0, 0, cw, chh);
    } else {
      await f.pdf.page.render({ canvasContext: ctx, viewport: f.pdf.page.getViewport({ scale: sc / 72, offsetX: -r.x * sc, offsetY: -r.y * sc }), background: 'rgba(0,0,0,0)' }).promise;
    }
    return cv;
  }

  // ============================== REVISAR ==============================
  function tipoDe(file) {
    var ext = (/\.([a-z0-9]+)$/i.exec(file.name || '') || [0, ''])[1].toLowerCase(), t = file.type || '';
    if (ext === 'png' || t === 'image/png') return 'png';
    if (ext === 'jpg' || ext === 'jpeg' || t === 'image/jpeg') return 'jpg';
    if (ext === 'webp' || t === 'image/webp') return 'webp';
    if (ext === 'svg' || t === 'image/svg+xml') return 'svg';
    if (ext === 'pdf' || t === 'application/pdf') return 'pdf';
    if (ext === 'ai') return 'ai';
    if (ext === 'psd' || ext === 'psb') return 'psd';
    return ext || 'other';
  }

  async function pngSize(file) {
    var b = new Uint8Array(await file.slice(0, 32).arrayBuffer());
    if (b.length < 24 || b[0] !== 0x89 || b[1] !== 0x50) throw new Error('bad-file');
    var w = ((b[16] << 24) | (b[17] << 16) | (b[18] << 8) | b[19]) >>> 0, h = ((b[20] << 24) | (b[21] << 16) | (b[22] << 8) | b[23]) >>> 0;
    return { w: w, h: h };
  }

  async function checkOne(f, progress, token) {
    if (f.file.size > MAX_MB * 1e6) throw new Error('too-big');
    if (['png', 'jpg', 'webp', 'svg', 'pdf', 'ai'].indexOf(f.tipo) < 0) throw new Error(f.tipo === 'psd' ? 'psd' : 'unsupported');
    await ensureEngine();
    var res;
    if (f.tipo === 'png' || f.tipo === 'jpg' || f.tipo === 'webp') {
      if (f.tipo === 'png') { var s = await pngSize(f.file); if (s.w * s.h / 1e6 > MAX_MP) throw new Error('too-large'); }
      res = await call({ cmd: 'check', file: f.file, name: f.name }, progress);
    } else {
      if (f.tipo === 'ai') {
        var hd = new Uint8Array(await f.file.slice(0, 1024).arrayBuffer()), txt = '';
        for (var i = 0; i < hd.length; i++) txt += String.fromCharCode(hd[i]);
        if (txt.indexOf('%PDF') < 0) throw new Error('ai-no-pdf');
      }
      res = await checkVector(f, progress, token);
    }
    res.imgW = res.vectorial ? res.anchoIn : res.w / 300;
    res.imgH = res.vectorial ? res.altoIn : res.h / 300;
    return res;
  }

  async function run(fileList) {
    var list = Array.prototype.slice.call(fileList || []);
    if (!list.length || state.busy) return;
    if (state.mode === 'single') list = list.slice(0, 1);
    state.files = list.slice(0, 8).map(function (file) { return { file: file, name: file.name, size: file.size, tipo: tipoDe(file) }; });
    state.active = 0; state.spot = -1; state.zoom = false; state.busy = true;
    var token = ++state.token;
    show('checking');
    for (var i = 0; i < state.files.length; i++) {
      var f = state.files[i];
      renderChecking(f, i);
      try {
        f.res = await checkOne(f, function (stage, frac) { if (token === state.token) updateProgress(stage, frac); }, token);
      } catch (e) {
        if (token !== state.token) return;
        f.error = (e && e.message) || 'error';
        if (f.error === 'cancelled') return;
        if (f.error === 'bad-png' || f.error === 'truncated' || f.error === 'png-unsupported') f.error = 'bad-file';
        if (f.error === 'no-canvas' || f.error === 'too-complex') f.error = 'too-large';
      }
      if (token !== state.token) return;
    }
    state.busy = false;
    var ok = state.files.filter(function (x) { return x.res; });
    if (!ok.length) { renderCant(state.files[0]); show('cant'); track('dpi_checker_cant_check', { reason: state.files[0].error, file_type: state.files[0].tipo }); return; }
    var peso = { fix: 0, look: 1, ready: 2 };
    ok.sort(function (a, b) { return peso[report(a).verdict] - peso[report(b).verdict]; });
    state.files = ok.concat(state.files.filter(function (x) { return !x.res; }));
    buildSpots();
    show('result');
    renderResult(true);
    var v = report(state.files[0]);
    track('dpi_checker_result', { verdict: v.verdict, mode: state.mode, file_type: state.files[0].tipo, errors: v.nErr, warnings: v.nWarn, files: ok.length });
    loadCrops(token);
  }

  // ============================== DEL RESULTADO AL INFORME ==============================
  var E = function () { return (worker ? null : mainEngine) || window.DPICEngine; };

  // reglas de tamaño: las mismas del motor, aquí para recalcular al cambiar el ancho sin releer el archivo
  function checkResolution(r, printW) {
    if (r.vectorial) return { level: 'ok', vector: true };
    var maxW = r.w / 300, maxH = r.h / 300;
    if (!printW) return { level: 'info', maxW: maxW, maxH: maxH };
    var eff = r.w / printW;
    return { level: eff >= 299.5 ? 'ok' : (eff < 200 ? 'error' : 'aviso'), eff: eff, maxW: maxW, maxH: maxH, printW: printW, printH: printW * r.h / r.w };
  }
  function checkSheet(r, sheetW) {
    var tol = 0.5, w = r.imgW, h = r.imgH, out = { w: w, h: h, sheetW: sheetW };
    if (Math.abs(w - sheetW) <= tol || Math.abs(h - sheetW) <= tol) { out.level = 'ok'; out.tipo = 'coincide'; }
    else if (w > sheetW + tol && h > sheetW + tol) { out.level = 'error'; out.tipo = 'grande'; }
    else if (r.vectorial) { out.level = 'info'; out.tipo = 'cabe'; }
    else {
      out.eff = r.w / sheetW; out.tipo = 'estrecha';
      out.declarada = !!(r.dpi && Math.abs(r.w / r.dpi - sheetW) <= tol);
      out.level = out.declarada ? (out.eff < 200 ? 'error' : 'aviso') : 'aviso';
    }
    return out;
  }
  function largoEnHoja(w, h, ancho) { return (Math.abs(w - ancho) > 0.5 && Math.abs(h - ancho) <= 0.5) ? w : h; }
  function totalOrden() {
    var medido = 0, n = 0;
    state.files.forEach(function (f) { if (f.res) { medido += largoEnHoja(f.res.imgW, f.res.imgH, state.sheetW); n++; } });
    var t = { archivos: n, medido: medido, comprado: state.sheetL };
    if (medido > state.sheetL + 0.5) t.estado = 'sobra';
    else if (medido < state.sheetL - 0.5) t.estado = 'falta';
    else t.estado = 'coincide';
    return t;
  }

  function finding(r, code) { for (var i = 0; i < r.findings.length; i++) if (r.findings[i].code === code) return r.findings[i]; return null; }

  // El informe de un archivo: tarjetas (rojo y ámbar), consejos y lo que pasó bien.
  function report(f) {
    var r = f.res, cards = [], tips = [], oks = [], gang = state.mode === 'gang';
    function card(level, key, title, body, fix, extra) {
      var c = { level: level, key: key, title: title, body: body, fix: fix };
      if (extra) for (var k in extra) c[k] = extra[k];
      cards.push(c);
      return c;
    }

    // --- tamaño ---
    if (!gang) {
      var cr = checkResolution(r, state.printW);
      f.sharp = cr;
      if (cr.vector) oks.push(['Resolution', 'Vector file: sharp at any size']);
      else if (cr.level === 'error' || cr.level === 'aviso') {
        card(cr.level, 'res', (cr.level === 'error' ? 'Blurry at ' : 'May look soft at ') + fin(cr.printW) + ' in wide',
          'Your image has enough detail for about ' + fin(cr.maxW) + ' in. At ' + fin(cr.printW) + ' in it would print at ' + Math.round(cr.eff) + ' DPI, and we print at 300.',
          'Upload a larger version, or print it smaller.', { action: { act: 'setw', value: Math.floor(cr.maxW * 10) / 10, label: 'Print at ' + fin(Math.floor(cr.maxW * 10) / 10) + ' in' } });
      } else if (cr.level === 'ok') oks.push(['Resolution', Math.min(999, Math.round(cr.eff)) + ' DPI at ' + fin(cr.printW) + ' in']);
      else oks.push(['Resolution', 'Sharp up to ' + fin(cr.maxW) + ' × ' + fin(cr.maxH) + ' in']);
    } else {
      var cs = checkSheet(r, state.sheetW), W = state.sheetW;
      if (cs.tipo === 'grande') card('error', 'sheet', 'Too big for a ' + W + ' in sheet', 'At 300 DPI your file is ' + fin(cs.w) + ' × ' + fin(cs.h) + ' in. Neither side fits a ' + W + ' in wide sheet.', 'Resize it to ' + W + ' in wide, or pick a wider sheet.');
      else if (cs.tipo === 'estrecha' && cs.declarada) card(cs.level, 'sheet', 'Low resolution for a ' + W + ' in sheet', 'Your file is ' + r.w + ' px wide. A ' + W + ' in sheet needs ' + (W * 300) + ' px at 300 DPI, so yours would print at ' + Math.round(cs.eff) + ' DPI.', 'Export the sheet again at 300 DPI.');
      else if (cs.tipo === 'estrecha') card('aviso', 'sheet', 'Narrower than the sheet', 'At 300 DPI your file is ' + fin(cs.w) + ' in wide, not ' + W + ' in. Stretched to ' + W + ' in, it would print at ' + Math.round(cs.eff) + ' DPI.', 'Export it at ' + (W * 300) + ' px wide. If the smaller size is what you want, leave it.');
      var t = totalOrden(), varios = t.archivos > 1;
      if (t.estado === 'sobra') card('error', 'total', 'Longer than the sheet you picked', (varios ? 'Your files add up to ' : 'Your file is ') + fin(t.medido) + ' in long, and you picked a ' + state.sheetL + ' in sheet.', 'Pick a longer sheet, or shorten the layout.');
      else if (t.estado === 'falta') {
        // solo se sugiere una hoja más corta si existe una en la que quepa
        var cabe = SHEETS[String(W)].lengths.filter(function (l) { return l >= t.medido - 0.5; })[0];
        var que = 'your ' + (varios ? 'files add up to ' : 'file is ') + fin(t.medido) + ' in long and you picked a ' + state.sheetL + ' in sheet. ';
        if (cabe && cabe < state.sheetL) tips.push(que + 'It fits the ' + ft(cabe) + ' sheet.');
        else if (state.sheetL - t.medido >= 6) tips.push(que + 'You have room for more designs.');
      }
      if (!cards.length) {
        oks.push(['Sheet size', cs.tipo === 'coincide' && t.estado === 'coincide' ? 'Matches your ' + W + ' × ' + state.sheetL + ' in sheet' : (cs.tipo === 'coincide' ? W + ' in wide' : 'Fits a ' + W + ' in sheet')]);
        if (!r.vectorial) oks.push(['Resolution', r.w + ' × ' + r.h + ' px at 300 DPI']);
      }
    }

    // --- lo que encontró el motor ---
    r.findings.forEach(function (h) {
      var d = h.data || {}, m = h.marks || [];
      if (h.code === 'raster') {
        card(h.level, 'raster', 'Low-resolution image inside the file', 'An image placed at ' + fin(d.anchoIn) + ' × ' + fin(d.altoIn) + ' in has only ' + Math.round(d.dpi) + ' DPI. It may print pixelated.', 'Replace it with a 300 DPI version.');
      } else if (h.code === 'cmyk') {
        card('aviso', 'cmyk', 'File is in CMYK', 'We print from RGB, so colors can shift when the file is converted.', 'Export it in RGB.');
      } else if (h.code === 'vacio') {
        card('aviso', 'vacio', 'Nothing to print', "We couldn't find any visible pixels in this file.", 'Check that you exported the right artboard or layer.');
      } else if (h.code === 'fondo') {
        if (h.level === 'error') {
          card('error', 'fondo', 'White background', (f.tipo === 'jpg' ? "JPG files can't have a transparent background. " : 'DTF prints every pixel. ') + 'The white box around your design would print as white ink.',
            'Remove the background and save it as a PNG with transparency. ' + link(URLS.canva, 'How to save it in Canva'), { frame: 'White background' });
        } else if (h.level === 'aviso') {
          card('aviso', 'fondo', 'No transparent background', "Your whole file will print, background included. That's fine for a photo or a full rectangle.",
            'If you only want the design to print, remove the background and save it as a PNG with transparency.');
        } else oks.push(['Background', 'Transparent']);
      } else if (h.code === 'semi') {
        if (h.level === 'ok') oks.push(['Shadows, glows and fades', 'None found']);
        else if (d.todo) card('error', 'semi', 'Faded design', "Your design is semi-transparent, like a layer set below 100% opacity. It would print faded and patchy.", 'Set it to 100% opacity and export again.');
        else card(h.level, 'semi', h.level === 'error' ? 'Semi-transparent areas' : 'Soft shadows, fades or blurry edges',
          'About ' + (d.frac * 100 < 1 ? '1' : Math.round(d.frac * 100)) + '% of your design is semi-transparent: shadows, glows, fades, or blurry edges from an enlarged image. DTF prints those areas as dots or patchy white.' + (d.fuera >= 2000 ? " Part of it sits outside the design: that's not an effect but leftovers from a background remover or a half-erased layer." : ''),
          'Make them solid, or remove them. If the edges are blurry, start from a larger, sharper original.', { marks: m, tag: 'Soft area' });
      } else if (h.code === 'trazos') {
        if (h.level === 'ok') oks.push(['Thin lines and small text', 'None found']);
        else if (h.level === 'error') card('error', 'trazos', 'Lines too thin', 'Parts of your design are thinner than 0.34 mm. They may not transfer and can peel.', 'Thicken them to at least 0.5 mm.', { marks: m, tag: 'Thin line' });
        else card('aviso', 'trazos', 'Thin lines', "Some lines or text are thinner than the 0.5 mm we recommend. They'll print, but may look weak on the garment.", 'Thicken them if you can.', { marks: m, tag: 'Thin line' });
      } else if (h.code === 'restos') {
        if (h.level === 'ok') oks.push(['Stray pixels', 'None found']);
        else card('aviso', 'restos', num(d.n) + ' tiny speck' + (d.n === 1 ? '' : 's') + ' outside the design', "They'd print as small dots on the garment.", "Delete them. They're marked on the preview.", { marks: m, tag: 'Speck' });
      } else if (h.code === 'invisibles') {
        card('error', 'invisibles', 'Leftover pixels outside the design', "There are faint, almost invisible pixels outside your design, usually left behind by a background remover or a half-erased layer. You can't see them on screen, but the printer prints them.", "Erase them and export again. They're marked on the preview.", { marks: m, tag: 'Faint area' });
      } else if (h.code === 'huecos') {
        if (h.level === 'ok') oks.push(['Gaps between parts', 'None too thin']);
        else card('error', 'huecos', 'Gaps too thin between parts', 'Some parts of your design are separated by gaps thinner than 0.25 mm. DTF lays white ink under the colors, and gaps that thin close up when pressed, so those parts print merged together.', 'Widen the gaps, or move those shapes apart.', { marks: m, tag: 'Thin gap' });
      } else if (h.code === 'pixelado') {
        if (h.level === 'ok') oks.push(['Edges', 'Crisp']);
        else card(h.level, 'pixelado', h.level === 'error' ? 'Enlarged a lot from a smaller file' : 'Enlarged from a smaller file',
          'The edges are soft and stepped, which happens when an image is enlarged. We measured about ' + (Math.round(d.grosor * 10) / 10) + ' px of edge blur; a file at its real size has about one. It will print blurry around the edges.',
          'Use the original file at its full size, not an enlarged copy.', { marks: m, tag: 'Soft edge' });
      }
    });

    // grosor medido al tamaño real del archivo: si se imprime más pequeño, las líneas adelgazan
    if (!gang && f.sharp && f.sharp.eff && f.sharp.eff > 375) {
      cards.forEach(function (c) { if (c.key === 'trazos') c.body += ' We measured them at the full size of your file (' + fin(f.sharp.maxW) + ' in wide). Printed smaller, they get thinner.'; });
    }

    // hoja con sitio libre al final
    if (gang) {
      var caja = finding(r, 'caja');
      if (caja && r.imgH > r.imgW * 1.5) {
        var libre = r.imgH - caja.data.y1;
        if (libre >= 6) tips.push('your designs end at ' + fin(caja.data.y1) + ' in, so the last ' + fin(libre) + ' in are empty. Room for more designs.');
      }
    }

    var ordenOk = ['Sheet size', 'Resolution', 'Edges', 'Background', 'Shadows, glows and fades', 'Thin lines and small text', 'Gaps between parts', 'Stray pixels'];
    oks.sort(function (a, b) { return ordenOk.indexOf(a[0]) - ordenOk.indexOf(b[0]); });
    var orden = { error: 0, aviso: 1 };
    cards.sort(function (a, b) { return orden[a.level] - orden[b.level]; });
    cards.forEach(function (c, i) { c.n = i + 1; });
    var nErr = cards.filter(function (c) { return c.level === 'error'; }).length, nWarn = cards.length - nErr;
    return { cards: cards, tips: tips, oks: oks, nErr: nErr, nWarn: nWarn, verdict: nErr ? 'fix' : (nWarn ? 'look' : 'ready') };
  }

  function headline(rep) {
    var gang = state.mode === 'gang';
    if (rep.nErr && rep.nWarn) return things(rep.nErr) + ' to Fix, ' + num(rep.nWarn) + ' Worth a Look';
    if (rep.nErr) return things(rep.nErr) + ' to Fix Before You Order';
    if (rep.nWarn) return things(rep.nWarn) + ' Worth a Look';
    return gang ? 'Your Gang Sheet Is Ready for DTF' : 'Your File Is Ready for DTF';
  }

  // ============================== SITIOS (dónde está cada problema) ==============================
  // Las zonas vecinas de un mismo problema (una fila de líneas finas, por ejemplo)
  // se juntan en un solo sitio, hasta 4 in de lado.
  function agrupar(marks) {
    var bs = marks.map(function (m) { return { x: m.x, y: m.y, w: m.w, h: m.h }; }), gap = 0.3, lim = 4, hubo = true;
    while (hubo) {
      hubo = false;
      for (var i = 0; i < bs.length && !hubo; i++) for (var j = i + 1; j < bs.length; j++) {
        var a = bs[i], b = bs[j];
        if (a.x > b.x + b.w + gap || b.x > a.x + a.w + gap || a.y > b.y + b.h + gap || b.y > a.y + a.h + gap) continue;
        var x0 = Math.min(a.x, b.x), y0 = Math.min(a.y, b.y), x1 = Math.max(a.x + a.w, b.x + b.w), y1 = Math.max(a.y + a.h, b.y + b.h);
        if (x1 - x0 > lim || y1 - y0 > lim) continue;
        bs[i] = { x: x0, y: y0, w: x1 - x0, h: y1 - y0 }; bs.splice(j, 1); hubo = true; break;
      }
    }
    return bs;
  }

  function buildSpots() {
    state.files.forEach(function (f) {
      if (!f.res) return;
      var rep = report(f), spots = [];
      rep.cards.forEach(function (c) {
        agrupar(c.marks || []).forEach(function (m) { spots.push({ key: c.key, level: c.level, tag: c.tag, m: m }); });
      });
      spots.sort(function (a, b) { return (a.level === b.level ? 0 : (a.level === 'error' ? -1 : 1)) || a.m.y - b.m.y || a.m.x - b.m.x; });
      f.spots = spots.slice(0, MAX_SPOTS);
      f.spots.forEach(function (s) {
        var lado = Math.min(6, Math.max(1, Math.max(s.m.w, s.m.h) * 2.5)), w = Math.min(lado, f.res.imgW), h = Math.min(lado, f.res.imgH);
        var x = Math.min(Math.max(0, s.m.x + s.m.w / 2 - w / 2), f.res.imgW - w), y = Math.min(Math.max(0, s.m.y + s.m.h / 2 - h / 2), f.res.imgH - h);
        s.r = { x: x, y: y, w: w, h: h };
      });
    });
  }

  async function loadCrops(token) {
    for (var i = 0; i < state.files.length; i++) {
      var f = state.files[i];
      if (!f.res || !f.spots || !f.spots.length) continue;
      try {
        if (f.res.vectorial) {
          for (var j = 0; j < f.spots.length; j++) {
            if (token !== state.token) return;
            f.spots[j].crop = await cropVector(f, f.spots[j].r, 840);
            if (i === state.active && j === state.spot) drawZoom();
          }
        } else {
          var ppi = 300, rects = f.spots.map(function (s) {
            var x = Math.max(0, Math.floor(s.r.x * ppi)), y = Math.max(0, Math.floor(s.r.y * ppi));
            var w = Math.max(1, Math.min(f.res.w - x, Math.round(s.r.w * ppi))), h = Math.max(1, Math.min(f.res.h - y, Math.round(s.r.h * ppi)));
            return { x: x, y: y, w: w, h: h, step: Math.max(1, Math.ceil(w / 840)) };
          });
          await ensureEngine();
          var crops = await call({ cmd: 'crops', file: f.file, name: f.name, rects: rects });
          if (token !== state.token) return;
          crops.forEach(function (c, k) {
            var cv = tileCanvas(c.w, c.h);
            cv.getContext('2d').putImageData(new ImageData(new Uint8ClampedArray(c.data.buffer || c.data), c.w, c.h), 0, 0);
            f.spots[k].crop = cv;
          });
          if (i === state.active) drawZoom();
        }
      } catch (e) { /* sin zoom: queda la vista general */ }
    }
  }

  // ============================== PANTALLAS ==============================
  function show(view) {
    $$('.dpic-view').forEach(function (v) { v.hidden = v.getAttribute('data-view') !== view; });
    root.setAttribute('data-state', view);
    if (view !== 'upload') { var top = root.getBoundingClientRect().top + window.pageYOffset - 90; if (window.pageYOffset > top) window.scrollTo(0, top); }
  }

  function chip(f, extra) {
    return '<div class="dpic-filechip">' + svg(IC.file, 16, 1.8) + '<span><strong>' + esc(f.name) + '</strong> · ' + extra + '</span></div>';
  }

  var STEPS = [['leer', 'Size and resolution'], ['fondo', 'Background'], ['restos', 'Shadows, fades and stray pixels'], ['trazos', 'Thin lines, gaps and edges']];
  function renderChecking(f, idx) {
    var gang = state.mode === 'gang', total = state.files.length;
    $('[data-view="checking"]').innerHTML =
      '<div class="dpic-checking">' + chip(f, fmb(f.size) + (gang ? ' · for a ' + state.sheetW + ' × ' + state.sheetL + ' in sheet' : '')) +
      '<h2 class="dpic-h2">' + (gang ? 'Checking Your Gang Sheet' : 'Checking Your Artwork') + (total > 1 ? ' (' + (idx + 1) + ' of ' + total + ')' : '') + '</h2>' +
      '<div class="dpic-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"><span data-bar></span></div>' +
      '<div class="dpic-barlabel"><strong data-pct>0%</strong></div>' +
      '<ul class="dpic-steps">' + STEPS.map(function (s) { return '<li data-step="' + s[0] + '"><i></i>' + s[1] + '</li>'; }).join('') + '</ul>' +
      '<p class="dpic-muted">Big sheets take up to a minute. Keep this tab open. Your file never leaves your computer.</p>' +
      '<button type="button" class="dpic-btn dpic-btn-line" data-act="cancel">Cancel</button></div>';
  }

  var STAGE_PCT = { fondo: 68, restos: 74, semi: 80, trazos: 86, huecos: 92, pixelado: 96 };
  function updateProgress(stage, frac) {
    var pct = stage === 'leer' ? Math.round(frac * 66) : (STAGE_PCT[stage] || 95);
    var bar = $('[data-bar]'), lab = $('[data-pct]');
    if (!bar) return;
    bar.style.width = pct + '%'; lab.textContent = pct + '%';
    bar.parentNode.setAttribute('aria-valuenow', pct);
    var order = ['leer', 'fondo', 'restos', 'trazos'], cur = order.indexOf(stage === 'semi' ? 'restos' : (stage === 'huecos' || stage === 'pixelado' ? 'trazos' : stage));
    if (stage === 'leer' && frac < 1) cur = 0;
    $$('.dpic-steps li').forEach(function (li, i) { li.className = i < cur ? 'is-done' : (i === cur ? 'is-now' : ''); });
  }

  var CANT = {
    psd: ["We Can't Check Photoshop Files Online Yet", 'Export it as a PNG with a transparent background and check it again. A PNG is usually much smaller, too.', ['File › Export › Export As', 'Format: PNG, with Transparency on', 'Come back and check the new file here'], 'In Photoshop'],
    unsupported: ["We Can't Check This File Type Yet", 'Export it as a PNG with a transparent background, or as a PDF, and check it again.'],
    'ai-no-pdf': ["This AI File Can't Be Opened Outside Illustrator", 'It was saved without PDF compatibility. Open it in Illustrator and export it as a PDF or a PNG, then check it again.', ['File › Save As', 'Check "Create PDF Compatible File"', 'Come back and check the new file here'], 'In Illustrator'],
    'too-large': ['Too Large to Check on This Device', 'This file needs more memory than your browser allows. Try it on a computer, or place your order as usual.'],
    'too-big': ['This File Is Over ' + MAX_MB + ' MB', 'Export it as a PNG at 300 DPI, which is usually much smaller, and check it again.'],
    'bad-file': ["We Couldn't Read This File", 'It may be damaged or saved in a format we do not recognize. Export it again as a PNG or a PDF and check it again.'],
    engine: ["The Checker Didn't Load", 'Reload the page and try again. If it keeps happening, place your order as usual.']
  };
  function renderCant(f) {
    var c = CANT[f.error] || CANT['bad-file'];
    $('[data-view="cant"]').innerHTML =
      '<div class="dpic-cant"><button type="button" class="dpic-backlink" data-act="again">' + svg(IC.back, 16) + ' Back</button>' +
      chip(f, fmb(f.size)) +
      '<div class="dpic-verdict dpic-v-cant">' + svg(IC.alert, 16, 2.2) + "Can't check this file</div>" +
      '<h2 class="dpic-h2">' + c[0] + '</h2><p class="dpic-p">' + c[1] + '</p>' +
      (c[2] ? '<div class="dpic-how"><div class="dpic-how-t">' + c[3] + '</div><ol>' + c[2].map(function (s) { return '<li>' + s + '</li>'; }).join('') + '</ol></div>' : '') +
      '<div class="dpic-actions"><button type="button" class="dpic-btn dpic-btn-main" data-act="again">Choose another file</button>' +
      '<a class="dpic-btn dpic-btn-line" href="' + esc(orderUrl()) + '" data-cta="continue">Continue to order</a></div>' +
      '<p class="dpic-muted">You can still place your order as usual.</p></div>';
  }

  function orderUrl() {
    if (state.mode === 'gang') return (URLS.sheets && URLS.sheets[String(state.sheetW)]) || URLS.gang || '#';
    return URLS.bySize || '#';
  }

  function cardHtml(c, f, gang) {
    var red = c.level === 'error', where = '';
    if (c.marks && c.marks.length && gang) {
      var ys = [];
      f.spots.forEach(function (s, i) { if (s.key === c.key) ys.push([Math.round(s.m.y + s.m.h / 2), i]); });
      var seen = {}, chips = [];
      ys.forEach(function (p) { if (!seen[p[0]] && chips.length < 8) { seen[p[0]] = 1; chips.push('<button type="button" class="dpic-where" data-act="spot" data-i="' + p[1] + '">' + p[0] + ' in</button>'); } });
      if (chips.length) where = '<div class="dpic-wherebar"><span>Where:</span>' + chips.join('') + (ys.length > chips.length ? '<span class="dpic-muted">and more</span>' : '') + '</div>';
    } else if (c.marks && c.marks.length) {
      var first = -1;
      f.spots.forEach(function (s, i) { if (first < 0 && s.key === c.key) first = i; });
      if (first >= 0) where = '<div class="dpic-wherebar"><button type="button" class="dpic-where" data-act="spot" data-i="' + first + '">Show me where</button></div>';
    }
    return '<div class="dpic-issue ' + (red ? 'is-red' : 'is-amber') + '">' +
      '<div class="dpic-issue-h">' + (gang ? '<span class="dpic-badge">' + c.n + '</span>' : svg(IC.alert, 22)) + '<div class="dpic-issue-t">' + esc(c.title) + '</div></div>' +
      '<p>' + c.body + '</p>' + where +
      '<div class="dpic-fixrow"><p><strong>How to fix:</strong> ' + c.fix + '</p>' +
      (c.action ? '<button type="button" class="dpic-btn-mini" data-act="' + c.action.act + '" data-value="' + c.action.value + '">' + esc(c.action.label) + '</button>' : '') + '</div></div>';
  }

  function sizeBar(f) {
    if (state.mode === 'single') {
      var s = f.sharp || {}, txt = s.vector ? 'Vector file: <strong>sharp at any size</strong>' : 'Prints sharp up to <strong>' + fin(s.maxW) + ' in wide</strong>';
      return '<div class="dpic-sizebar"><label for="dpic-w2">Print width</label><span class="dpic-field"><input id="dpic-w2" type="text" inputmode="decimal" autocomplete="off" placeholder="Auto" value="' + (state.printW ? fin(state.printW) : '') + '" data-in="printw"><em>in</em></span><span class="dpic-sep"></span><span class="dpic-sharp">' + txt + '</span></div>';
    }
    var ws = Object.keys(SHEETS).map(function (w) { return '<option value="' + w + '"' + (+w === state.sheetW ? ' selected' : '') + '>' + w + ' in wide</option>'; }).join('');
    var ls = SHEETS[String(state.sheetW)].lengths.map(function (l) { return '<option value="' + l + '"' + (l === state.sheetL ? ' selected' : '') + '>' + ft(l) + '</option>'; }).join('');
    return '<div class="dpic-sizebar"><label for="dpic-sw2">Your sheet</label><select id="dpic-sw2" data-in="sheetw">' + ws + '</select><span aria-hidden="true">×</span><select data-in="sheetl" aria-label="Sheet length">' + ls + '</select></div>';
  }

  function readyHtml() {
    var gang = state.mode === 'gang', f = state.files[state.active], rows = [], s = f.sharp || {};
    function row(main, t, d, href, label, cta) {
      return '<div class="dpic-order' + (main ? ' is-main' : '') + '"><div><div class="dpic-order-t">' + t + '</div><div class="dpic-order-d">' + d + '</div></div>' +
        '<a class="dpic-btn ' + (main ? 'dpic-btn-main' : 'dpic-btn-line') + '" href="' + esc(href || '#') + '" data-cta="' + cta + '">' + label + (main ? svg(IC.next, 16) : '') + '</a></div>';
    }
    if (gang) {
      var name = SHEETS[String(state.sheetW)].name;
      rows.push(row(true, state.sheetW + ' in ' + name, 'Pick the ' + ft(state.sheetL) + ' length and upload this file. No minimums, no setup fees.', orderUrl(), 'Order This Sheet', 'sheet'));
      if (state.sheetW === 22) rows.push(row(false, 'Need It Today?', 'Order Same-Day DTF by 12 PM ET, Mon-Fri, to ship today, or by 3 PM ET for free pickup in Kendall.', URLS.sameDay, 'See Same-Day', 'same_day'));
    } else {
      var size = state.printW ? fin(state.printW) + ' × ' + fin(s.printH || state.printW) + ' in, any quantity. ' : 'Each design at the exact size you need. ';
      rows.push(row(true, 'DTF Transfers by Size', size + 'No minimums, no setup fees.', URLS.bySize, 'Order by Size', 'by_size'));
      rows.push(row(false, 'Add It to a Gang Sheet', 'Combine it with other designs on one sheet, 22, 24 or 30 in wide.', URLS.builder, 'Open the builder', 'builder'));
      rows.push(row(false, 'Need It Today?', 'Order Same-Day DTF by 12 PM ET, Mon-Fri, to ship today, or by 3 PM ET for free pickup in Kendall.', URLS.sameDay, 'See Same-Day', 'same_day'));
    }
    return '<div class="dpic-orders"><div class="dpic-h3">How Do You Want to Order It?</div>' + rows.join('') + '</div>';
  }

  function renderResult(first) {
    var f = state.files[state.active], r = f.res, gang = state.mode === 'gang', rep = report(f);
    var strip = gang && r.imgH > r.imgW * 1.6;
    var vp = { fix: ['dpic-v-fix', IC.alert, 'Needs fixing'], look: ['dpic-v-look', IC.alert, 'Worth a look'], ready: ['dpic-v-ready', IC.check, 'Ready to print'] }[rep.verdict];
    var tabs = '';
    if (state.files.length > 1) {
      tabs = '<div class="dpic-tabs" role="tablist">' + state.files.map(function (x, i) {
        var v = x.res ? report(x).verdict : 'cant';
        return '<button type="button" role="tab" aria-selected="' + (i === state.active) + '" data-act="tab" data-i="' + i + '"' + (x.res ? '' : ' disabled') + '><i class="dpic-dot dpic-dot-' + v + '"></i>' + esc(x.name) + '</button>';
      }).join('') + '</div>';
    }
    var dims = r.vectorial ? fin(r.anchoIn) + ' × ' + fin(r.altoIn) + ' in · vector' : r.w + ' × ' + r.h + ' px';
    var oks = rep.oks.map(function (o) { return '<div class="dpic-ok">' + svg(IC.okc, 20, 2.2) + '<span>' + o[0] + '</span><em>' + o[1] + '</em></div>'; }).join('');
    var body = rep.cards.map(function (c) { return cardHtml(c, f, gang); }).join('') +
      rep.tips.map(function (t) { return '<div class="dpic-tip">' + svg(IC.tip, 20, 1.8) + '<p><strong>Tip:</strong> ' + t + '</p></div>'; }).join('');
    var otros = state.files.some(function (x, i) { return i !== state.active && (!x.res || report(x).verdict !== 'ready'); });
    var actions = rep.verdict === 'ready' ? (otros ? '<div class="dpic-tip">' + svg(IC.tip, 20, 1.8) + '<p><strong>One more to go:</strong> another file in this order needs a look. Open its tab above.</p></div>' : readyHtml()) :
      '<div class="dpic-actions"><button type="button" class="dpic-btn dpic-btn-main" data-act="again">' + svg(IC.up, 18) + 'Upload a new version</button>' +
      '<a class="dpic-btn dpic-btn-line" href="' + esc(orderUrl()) + '" data-cta="continue">Continue to order</a></div>' +
      '<p class="dpic-muted">You can still order with this file. We print it as you upload it.</p>';

    $('[data-view="result"]').innerHTML =
      '<div class="dpic-res-top"><button type="button" class="dpic-backlink" data-act="again">' + svg(IC.back, 16) + ' Check another file</button>' + chip(f, dims) + '</div>' + tabs +
      '<div class="dpic-res-grid' + (strip ? ' has-strip' : '') + '">' +
      '<div class="dpic-viewer">' +
      (strip ? '<div class="dpic-stripcol"><div class="dpic-cap">Your sheet · ' + fin(r.imgW) + ' × ' + fin(r.imgH) + ' in</div><div class="dpic-stripscroll"><div class="dpic-strip" data-strip></div></div></div>' : '') +
      '<div class="dpic-stagecol"><div class="dpic-stage dpic-checker" data-stage></div><div class="dpic-stagebar" data-stagebar></div></div>' +
      '</div>' +
      '<div class="dpic-report"><div class="dpic-verdict ' + vp[0] + '">' + svg(vp[1], 16, 2.3) + vp[2] + '</div>' +
      '<h2 class="dpic-h2">' + (rep.verdict === 'ready' && otros ? 'This File Is Ready for DTF' : headline(rep)) + '</h2>' + sizeBar(f) +
      (rep.verdict === 'ready' ? '<div class="dpic-oks is-all">' + oks + '</div>' : body + (oks ? '<details class="dpic-also"><summary>Also checked: ' + rep.oks.length + ' passed</summary><div class="dpic-oks">' + oks + '</div></details>' : '')) +
      actions + '</div></div>';

    f.rep = rep; f.strip = strip;
    if (strip && state.spot < 0 && f.spots.length) state.spot = 0;
    if (strip) drawStrip();
    drawStage();
  }

  // ============================== VISTA PREVIA, TIRA Y ZOOM ==============================
  function previewCanvas(f) {
    if (!f.pcv) {
      var p = f.res.preview, cv = tileCanvas(p.w, p.h);
      cv.getContext('2d').putImageData(new ImageData(new Uint8ClampedArray(p.data.buffer || p.data), p.w, p.h), 0, 0);
      f.pcv = cv;
    }
    return f.pcv;
  }

  function markBox(m, r, cls, label, i) {
    return '<button type="button" class="dpic-mark ' + cls + '" data-act="spot" data-i="' + i + '" aria-label="' + esc(label) + '" style="left:' + (m.x - r.x) / r.w * 100 + '%;top:' + (m.y - r.y) / r.h * 100 + '%;width:' + m.w / r.w * 100 + '%;height:' + m.h / r.h * 100 + '%"></button>';
  }

  function drawStage() {
    var f = state.files[state.active], stage = $('[data-stage]'), bar = $('[data-stagebar]');
    if (!stage) return;
    var zoomed = f.strip ? state.spot >= 0 : (state.zoom && state.spot >= 0);
    if (zoomed) { drawZoom(); return; }
    var r = f.res, full = { x: 0, y: 0, w: r.imgW, h: r.imgH }, html = '<div class="dpic-fit" data-fit>';
    html += '<canvas data-pv></canvas>';
    (f.spots || []).forEach(function (s, i) { html += markBox(s.m, full, s.level === 'error' ? 'is-red' : 'is-amber', s.tag, i); });
    f.rep.cards.forEach(function (c) { if (c.frame) html += '<div class="dpic-frame" aria-hidden="true"><span>' + c.frame + '</span></div>'; });
    html += '</div>';
    stage.innerHTML = html;
    fitBox(stage, r.imgW / r.imgH);
    var cv = $('[data-pv]', stage), src = previewCanvas(f);
    cv.width = src.width; cv.height = src.height;
    cv.getContext('2d').drawImage(src, 0, 0);
    bar.innerHTML = '<span class="dpic-muted">' + (f.strip ? 'No problems to show on this sheet.' : (f.spots && f.spots.length ? 'Preview. Click a mark to zoom in.' : (f.rep.cards.some(function (c) { return c.frame; }) ? 'Preview. The dashed line shows what would print.' : 'Preview. The checkered area is transparent and won\'t print.'))) + '</span>';
  }

  // encaja una caja con esa proporción dentro del escenario
  function fitBox(stage, ratio) {
    var box = $('[data-fit]', stage), W = stage.clientWidth - 32, H = stage.clientHeight - 32;
    if (!box || W <= 0 || H <= 0) return;
    var w = Math.max(40, Math.min(W, H * ratio));
    box.style.width = w + 'px'; box.style.height = (w / ratio) + 'px';
  }

  function drawZoom() {
    var f = state.files[state.active], stage = $('[data-stage]'), bar = $('[data-stagebar]');
    if (!stage || state.spot < 0 || !f.spots || !f.spots[state.spot]) return;
    var s = f.spots[state.spot], r = s.r, n = f.spots.length;
    var html = '<div class="dpic-fit" data-fit><canvas data-zm></canvas>';
    f.spots.forEach(function (o, i) {
      if (o.m.x + o.m.w < r.x || o.m.x > r.x + r.w || o.m.y + o.m.h < r.y || o.m.y > r.y + r.h) return;
      html += markBox(o.m, r, (o.level === 'error' ? 'is-red' : 'is-amber') + (i === state.spot ? ' is-on' : ''), o.tag, i);
    });
    html += '</div><div class="dpic-zoomtag ' + (s.level === 'error' ? 'is-red' : 'is-amber') + '">' + esc(s.tag) + ' · ' + fin(s.m.y + s.m.h / 2) + ' in from the top · ' + fin(s.m.x + s.m.w / 2) + ' in from the left</div>';
    if (!s.crop) html += '<div class="dpic-loading">Loading the close-up…</div>';
    stage.innerHTML = html;
    fitBox(stage, r.w / r.h);
    var cv = $('[data-zm]', stage), ctx;
    if (s.crop) { cv.width = s.crop.width; cv.height = s.crop.height; cv.getContext('2d').drawImage(s.crop, 0, 0); }
    else {
      // mientras llega el recorte, la vista general ampliada
      var src = previewCanvas(f), k = src.width / f.res.imgW;
      cv.width = Math.max(1, Math.round(r.w * k)); cv.height = Math.max(1, Math.round(r.h * k));
      ctx = cv.getContext('2d'); ctx.imageSmoothingEnabled = false;
      ctx.drawImage(src, r.x * k, r.y * k, r.w * k, r.h * k, 0, 0, cv.width, cv.height);
    }
    bar.innerHTML = (f.strip ? '' : '<button type="button" class="dpic-btn-mini" data-act="full">Full view</button>') +
      '<span class="dpic-nav"><button type="button" class="dpic-btn-mini" data-act="prev"' + (n < 2 ? ' disabled' : '') + '>Previous</button><span>Spot ' + (state.spot + 1) + ' of ' + n + '</span><button type="button" class="dpic-btn-mini" data-act="next"' + (n < 2 ? ' disabled' : '') + '>Next</button></span>';
    if (f.strip) {
      $$('.dpic-pin').forEach(function (p) { p.classList.toggle('is-on', +p.getAttribute('data-i') === state.spot); });
      var sc = $('.dpic-stripscroll'), pin = $('.dpic-pin.is-on');
      if (sc && pin) sc.scrollTop = Math.max(0, pin.offsetTop - sc.clientHeight / 2);
    }
  }

  function drawStrip() {
    var f = state.files[state.active], el = $('[data-strip]'), r = f.res;
    if (!el) return;
    var W = window.innerWidth < 900 ? 84 : 120, H = Math.round(W * r.imgH / r.imgW), step = r.imgH > 150 ? 24 : 12, html = '<div class="dpic-ruler" style="height:' + H + 'px">';
    for (var t = 0; t <= r.imgH + 0.01; t += step) html += '<span style="top:' + (t / r.imgH * 100) + '%">' + t + '</span>';
    html += '</div><div class="dpic-sheet dpic-checker" style="width:' + W + 'px;height:' + H + 'px"><canvas data-sv></canvas>';
    (f.spots || []).forEach(function (s, i) {
      var c = null;
      f.rep.cards.forEach(function (k) { if (k.key === s.key) c = k; });
      html += '<button type="button" class="dpic-pin ' + (s.level === 'error' ? 'is-red' : 'is-amber') + '" data-act="spot" data-i="' + i + '" aria-label="' + esc(s.tag) + ' at ' + Math.round(s.m.y) + ' in" style="top:' + ((s.m.y + s.m.h / 2) / r.imgH * 100) + '%;left:' + ((s.m.x + s.m.w / 2) / r.imgW * 100) + '%">' + (c ? c.n : '') + '</button>';
    });
    html += '</div>';
    el.innerHTML = html;
    var cv = $('[data-sv]', el), src = previewCanvas(f);
    cv.width = src.width; cv.height = src.height;
    cv.getContext('2d').drawImage(src, 0, 0);
  }

  // ============================== OPCIONES DE LA PANTALLA DE SUBIDA ==============================
  function parseIn(v) { var x = parseFloat(String(v).replace(',', '.')); return (isFinite(x) && x > 0 && x <= 400) ? x : null; }

  function setMode(mode) {
    state.mode = mode;
    $$('[data-mode]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-mode') === mode)); });
    $$('[data-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-pane') !== mode; });
    $$('[data-when]').forEach(function (p) { p.hidden = p.getAttribute('data-when') !== mode; });
    var inp = $('[data-file]');
    if (inp) { if (mode === 'gang') inp.setAttribute('multiple', ''); else inp.removeAttribute('multiple'); }
    var t = $('[data-size-title]');
    if (t) t.textContent = mode === 'gang' ? 'What Are You Ordering?' : 'How Big Will You Print It?';
    syncSheet();
  }

  function syncSheet() {
    var sel = $('[data-in="sheetl-up"]'), L = SHEETS[String(state.sheetW)].lengths;
    if (L.indexOf(state.sheetL) < 0) state.sheetL = L.indexOf(120) >= 0 ? 120 : L[0];
    if (sel) sel.innerHTML = L.map(function (l) { return '<option value="' + l + '"' + (l === state.sheetL ? ' selected' : '') + '>' + ft(l) + '</option>'; }).join('');
    $$('[data-sheetw]').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-sheetw') === state.sheetW)); });
    var note = $('[data-sheetnote]');
    if (note) note.textContent = "We'll check your file against a " + state.sheetW + ' × ' + state.sheetL + ' in sheet: width, length and 300 DPI.';
  }

  function reRender() { buildSpots(); state.spot = -1; state.zoom = false; renderResult(false); loadCrops(state.token); }

  // ============================== EVENTOS ==============================
  root.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-act],[data-mode],[data-sheetw],[data-pick],[data-cta]');
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-cta')) { track('dpi_checker_cta', { cta: t.getAttribute('data-cta'), mode: state.mode }); return; }
    if (t.hasAttribute('data-mode')) { setMode(t.getAttribute('data-mode')); return; }
    if (t.hasAttribute('data-sheetw')) { state.sheetW = +t.getAttribute('data-sheetw'); syncSheet(); return; }
    if (t.hasAttribute('data-pick')) { $('[data-file]').click(); return; }
    var act = t.getAttribute('data-act'), f = state.files[state.active];
    if (act === 'cancel') { cancelAll(); state.busy = false; show('upload'); }
    else if (act === 'again') { cancelAll(); state.busy = false; state.files = []; show('upload'); var d = $('[data-drop]'); if (d) d.scrollIntoView({ block: 'center' }); }
    else if (act === 'tab') { state.active = +t.getAttribute('data-i'); state.spot = -1; state.zoom = false; renderResult(false); }
    else if (act === 'spot') { state.spot = +t.getAttribute('data-i'); state.zoom = true; drawZoom(); var st = $('[data-stage]'); if (st && window.innerWidth < 900) st.scrollIntoView({ block: 'center' }); }
    else if (act === 'full') { state.zoom = false; drawStage(); }
    else if (act === 'prev' || act === 'next') { var n = f.spots.length; state.spot = (state.spot + (act === 'next' ? 1 : n - 1)) % n; drawZoom(); }
    else if (act === 'setw') { state.printW = parseFloat(t.getAttribute('data-value')); var w1 = $('[data-in="printw-up"]'); if (w1) w1.value = fin(state.printW); renderResult(false); }
  });

  root.addEventListener('change', function (ev) {
    var t = ev.target, k = t.getAttribute && t.getAttribute('data-in');
    if (t.hasAttribute && t.hasAttribute('data-file')) { run(t.files); t.value = ''; return; }
    if (!k) return;
    if (k === 'printw') { state.printW = parseIn(t.value); var up = $('[data-in="printw-up"]'); if (up) up.value = state.printW ? fin(state.printW) : ''; renderResult(false); }
    else if (k === 'printw-up') { state.printW = parseIn(t.value); }
    else if (k === 'sheetl-up') { state.sheetL = +t.value; syncSheet(); }
    else if (k === 'sheetw') { state.sheetW = +t.value; syncSheet(); reRender(); }
    else if (k === 'sheetl') { state.sheetL = +t.value; syncSheet(); reRender(); }
  });
  root.addEventListener('keydown', function (ev) {
    if (ev.key === 'Enter' && ev.target.getAttribute && ev.target.getAttribute('data-in') === 'printw') { ev.preventDefault(); ev.target.blur(); }
  });

  var drop = $('[data-drop]');
  if (drop) {
    ['dragenter', 'dragover'].forEach(function (n) { drop.addEventListener(n, function (ev) { ev.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (n) { drop.addEventListener(n, function (ev) { ev.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (ev) { if (ev.dataTransfer && ev.dataTransfer.files) run(ev.dataTransfer.files); });
  }
  // soltar fuera del recuadro no debe abrir el archivo en la pestaña
  window.addEventListener('dragover', function (ev) { if (root.getAttribute('data-state') !== 'checking') ev.preventDefault(); });
  window.addEventListener('drop', function (ev) { ev.preventDefault(); });
  window.addEventListener('resize', function () { if (root.getAttribute('data-state') === 'result') { var f = state.files[state.active]; if (f && f.res) drawStage(); } });

  setMode('single');
  root.setAttribute('data-state', 'upload');
  root.classList.add('is-ready');
  window.DPIChecker = { run: run, state: state };
})();
